import { Link, NavLink, useLocation } from "react-router-dom";
import "./sidebar.scss";
import { permissions } from "../../../roles";

const Sidebar = () => {
  const role = atob(sessionStorage.getItem("key") || "");
  const location = useLocation();
  const hideSidebar = ["/otp", "/survey"]
  const isSurveyUser = hideSidebar.includes(location.pathname);
  // location.pathname.startsWith(hideSidebar)
  const handleLogout = () => {
    sessionStorage.clear();
    window.location.assign(`${process.env.REACT_APP_COGNITOSSO_LOGOUT_URL}`);
  };
  return (
    <nav>
      <ul>
        {!isSurveyUser && (
          <li>
            <Link to="">
              <div>
                <img
                  className="sidebar_img"
                  src={require("../../../images/avatar.png")}
                  alt=""
                />
                <span>{`${sessionStorage.getItem(
                  "Product_FIRSTNAME"
                )} ${sessionStorage.getItem("Product_LASTNAME")}`}</span>
                {/* <span>User</span> */}

              </div>
            </Link>
          </li>
        )}
        {!isSurveyUser ? (
          <>
            <li>
              <NavLink
                to="/dashboard"
                style={({ isActive }) => {
                  return isActive
                    ? {
                        backgroundColor: "rgb(215, 211, 211)",
                        boxShadow: "2px 2px 4px grey",
                      }
                    : { backgroundColor: "" };
                }}
              >
                <div>
                  <img
                    className="sidebar_img"
                    src={require("../../../images/dashboard.png")}
                    alt=""
                  />
                  <span>Dashboard</span>
                </div>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/assessment"
                style={({ isActive }) => {
                  return isActive
                    ? {
                        backgroundColor: "rgb(215, 211, 211)",
                        boxShadow: "2px 2px 4px grey",
                      }
                    : { backgroundColor: "" };
                }}
              >
                <div>
                  <img
                    className="sidebar_img"
                    src={require("../../../images/assessment.png")}
                    alt=""
                  />
                  <span>Create Assessment</span>
                </div>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/survey-creation"
                style={({ isActive }) => {
                  return isActive
                    ? {
                        backgroundColor: "rgb(215, 211, 211)",
                        boxShadow: "2px 2px 4px grey",
                      }
                    : { backgroundColor: "" };
                }}
              >
                <div>
                  <img
                    className="sidebar_img"
                    src={require("../../../images/survey.png")}
                    alt=""
                  />
                  <span>Survey Creation</span>
                </div>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/access-management"
                style={({ isActive }) => {
                  return isActive
                    ? {
                        backgroundColor: "rgb(215, 211, 211)",
                        boxShadow: "2px 2px 4px grey",
                      }
                    : { backgroundColor: "" };
                }}
              >
                <div>
                  <img
                    className="sidebar_img"
                    src={require("../../../images/access.png")}
                    alt=""
                  />
                  <span>Access Management</span>
                </div>
              </NavLink>
            </li>
          </>
        ) : (
          <li>
            <NavLink
              to="/otp"
              style={({ isActive }) => {
                return isActive
                  ? {
                      backgroundColor: "rgb(215, 211, 211)",
                      boxShadow: "2px 2px 4px grey",
                    }
                  : { backgroundColor: "" };
              }}
            >
              <div>
                <img
                  className="sidebar_img"
                  src={require("../../../images/survey.png")}
                  alt=""
                />
                <span>Survey Submission</span>
              </div>
            </NavLink>
          </li>
        )}
        {!isSurveyUser && (
          <li className="logout" onClick={handleLogout}>
            <a style={{ cursor: "pointer" }}>
              <div>
                <img
                  className="sidebar_img"
                  src={require("../../../images/logout.png")}
                  alt=""
                />
                <span>Logout</span>
              </div>
            </a>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Sidebar;
